import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { Tooltip } from "@mui/material";
import React from "react";
import { useDispatch } from "react-redux";
import { downloadEstadoCuentaCorriente } from "../../redux/actions/cuentaCorriente";
import { downloadFile } from "../../util/files";
import { StyledEstadoButton } from "../styled/CuentaCorriente";


const ReporteEstadoButton = ({ disabled, color, tipoContrato }) => {

  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(downloadEstadoCuentaCorriente(tipoContrato)).then((response) => {
      downloadFile(response.value.data, response.value.fileName);
    });
  }

  return (
    <StyledEstadoButton.Container>
      <Tooltip title="Descargar Estado de cuenta corriente al último cierre" arrow>
        <span>
          <StyledEstadoButton.Icon
            disabled={disabled}
            size="medium"
            onClick={handleClick}
            color={color}
          >
            <PictureAsPdfIcon />
          </StyledEstadoButton.Icon>
        </span>
      </Tooltip>
    </StyledEstadoButton.Container>
  );
};

export default ReporteEstadoButton;
